import React from 'react';

import { Alert, Button, Col, Row, Select, Spin } from 'antd';

import { Field } from '../../../models/Field';
import { FieldCropHistory } from '../../../models/FieldCropHistory';

const { Option } = Select;

interface Props {
    fields: Field[];
    seasons: FieldCropHistory[];
    selectedFieldId?: number;
    selectedSeason?: number;
    onFieldChange: (id: number) => void;
    onSeasonChange: (year: number) => void;
    onLoad: () => void;
    onPrint: () => void;
    loading: boolean;
    hasData: boolean;
    fieldsLoading: boolean;
    seasonsLoading: boolean;
}

export default function ReportHeader(props: Props) {
    const {
        fields,
        seasons,
        selectedFieldId,
        selectedSeason,
        onFieldChange,
        onSeasonChange,
        onLoad,
        onPrint,
        loading,
        hasData,
        fieldsLoading,
        seasonsLoading,
    } = props;

    const noFields = !fieldsLoading && fields.length === 0;
    const noSeasons =
        !!selectedFieldId && !seasonsLoading && seasons.length === 0;

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            {/* Поле или сообщение, если их нет */}
            <Col xs={24} md={12} lg={8}>
                {noFields ? (
                    <Alert
                        type="info"
                        showIcon
                        message="Нет полей"
                        description="Отчёт строится по полю. Создайте поле на странице «Мои поля»."
                    />
                ) : (
                    <Select
                        showSearch
                        placeholder="Поле"
                        style={{ width: '100%' }}
                        size="large"
                        loading={fieldsLoading}
                        value={selectedFieldId}
                        onChange={onFieldChange}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            String(option?.children ?? '')
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {fields.map((f) => (
                            <Option key={f.id} value={f.id}>
                                {`${f.name || 'Поле'} (#${f.id})`}
                            </Option>
                        ))}
                    </Select>
                )}
            </Col>

            {/* Сезон или сообщение */}
            <Col xs={24} md={12} lg={8}>
                {noSeasons ? (
                    <Alert
                        type="info"
                        showIcon
                        message="У поля нет сезонов"
                        description="Добавьте сезон на странице поля."
                    />
                ) : (
                    <Select
                        placeholder="Сезон"
                        style={{ width: '100%' }}
                        size="large"
                        loading={seasonsLoading}
                        value={selectedSeason}
                        onChange={onSeasonChange}
                        disabled={!selectedFieldId}
                    >
                        {seasons.map((s) => (
                            <Option key={s.season_harvest} value={s.season_harvest}>
                                {s.season_harvest} (посев {s.season_sowing})
                            </Option>
                        ))}
                    </Select>
                )}
            </Col>

            {/* Кнопки */}
            <Col xs={24} lg={8}>
                <Button
                    type="primary"
                    onClick={onLoad}
                    loading={loading}
                    disabled={!selectedFieldId || !selectedSeason || noSeasons}
                    style={{ marginRight: 8 }}
                >
                    Построить отчёт
                </Button>
                <Button onClick={onPrint} disabled={!hasData}>
                    Печать / PDF
                </Button>
            </Col>
        </Row>
    );
}
